class IngredientsSelector {
  constructor() {
    this.selectedIngredient = null;
    this.ingredientItems = document.querySelectorAll('.ingredient-item');
    this.ingredientImage = document.getElementById('ingredient-image');
    this.ingredientDetail = document.querySelector('.ingredient-detail');

    this.init();
  }

  init() {
    this.attachEventListeners();
    this.selectFirstIngredient();
  }

  selectIngredient(item) {
    this.selectedIngredient = {
      title: item.dataset.ingredientTitle,
      image: item.dataset.ingredientImage,
      description: item.dataset.ingredientDescription
    };

    this.updateActiveState(item);
    this.updateImage();
    this.updateDescription();
    this.dispatchEvent();
  }

  updateActiveState(activeItem) {
    this.ingredientItems.forEach(item => item.classList.remove('active'));
    activeItem.classList.add('active');
  }

  updateImage() {
    if (this.ingredientImage && this.selectedIngredient.image) {
      // Fade out
      this.ingredientImage.style.opacity = '0';

      // Wait for fade out, then change image and fade in
      setTimeout(() => {
        this.ingredientImage.src = this.selectedIngredient.image;
        this.ingredientImage.alt = this.selectedIngredient.title;
        this.ingredientImage.classList.add('active');

        // Trigger fade in
        requestAnimationFrame(() => {
          this.ingredientImage.style.opacity = '1';
        });
      }, 150);
    }
  }

  updateDescription() {
    if (this.ingredientDetail && this.selectedIngredient.description) {
      // Fade out
      this.ingredientDetail.style.opacity = '0';

      // Wait for fade out, then change text and fade in
      setTimeout(() => {
        this.ingredientDetail.textContent = this.selectedIngredient.description;

        // Trigger fade in
        requestAnimationFrame(() => {
          this.ingredientDetail.style.opacity = '1';
        });
      }, 150);
    }
  }

  dispatchEvent() {
    const event = new CustomEvent('ingredientSelected', {
      detail: this.selectedIngredient
    });
    document.dispatchEvent(event);
  }

  attachEventListeners() {
    this.ingredientItems.forEach(item => {
      item.addEventListener('click', () => this.selectIngredient(item));
    });
  }

  selectFirstIngredient() {
    if (this.ingredientItems.length > 0) {
      this.selectIngredient(this.ingredientItems[0]);
    }
  }

  getSelected() {
    return this.selectedIngredient;
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.ingredientsSelector = new IngredientsSelector();
  });
} else {
  window.ingredientsSelector = new IngredientsSelector();
}

// Expose getter function for backward compatibility
window.getSelectedIngredient = function() {
  return window.ingredientsSelector?.getSelected() || null;
};
